// Global packages and components
import { Button, Heading, Slider, TikTokLister } from '~/components'

// Types
import type { SanityButtonProps, TikTokListingItem } from '~/types'

interface Props {
  title: string
  listerPage: SanityButtonProps
  items: TikTokListingItem[]
}

// Main export
export default function BlockTikTok({ title, listerPage, items }: Props) {
  return (
    <div className="container">
      {title && (
        <Heading
          className="mb-10 text-center"
          tag="h2"
          size="h4"
        >
          {title}
        </Heading>
      )}
      <Slider
        className="-mx-2 mb-14 lg:[&_.splide\_\_track]:grid"
        arrowsInline
        options={{
          arrows: true,
          pagination: false,
          perPage: 2,
          breakpoints: {
            768: {
              perPage: 3,
            },
            1024: {
              perPage: 4,
            },
          },
        }}
      >
        {items.map((e, i) => (
          <div
            className="h-full px-2"
            key={i}
          >
            <TikTokLister {...e} />
          </div>
        ))}
      </Slider>
      <div className="flex justify-center">
        <Button {...listerPage} />
      </div>
    </div>
  )
}
